import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface TacticLinkStatus {
  linked: boolean;
  tactic_company_name: string | null;
  is_admin: boolean;
}

/** ¿Esta empresa está conectada con Ulture Tactic? (lo guarda Tactic; se pregunta por app-switch) */
export function useTacticLink(companyId: string | null | undefined) {
  return useQuery({
    queryKey: ["tactic-link", companyId],
    enabled: !!companyId,
    staleTime: 5 * 60_000,
    queryFn: async (): Promise<TacticLinkStatus> => {
      const { data, error } = await supabase.functions.invoke("app-switch", { body: { action: "status" } });
      if (error) return { linked: false, tactic_company_name: null, is_admin: false };
      return {
        linked: data?.linked === true,
        tactic_company_name: data?.tactic_company_name ?? null,
        is_admin: data?.is_admin === true,
      };
    },
  });
}
